<footer class="app-footer">
    <span class="footer-copyright">© 2026 Veralora</span>
    <nav class="footer-links" aria-label="Footer links">
        <a routerLink="/acceptable-use" matButton class="footer-link">Acceptable Use</a>
        <span class="footer-separator" aria-hidden="true">|</span>
        <a routerLink="/subscription-billing-policy" matButton class="footer-link">Billing</a>
        <span class="footer-separator" aria-hidden="true">|</span>
        <a routerLink="/cookie-policy" matButton class="footer-link">Cookies</a>
        <span class="footer-separator" aria-hidden="true">|</span>
        <a routerLink="/privacy-policy" class="footer-link" matButton>Privacy</a>
        <span class="footer-separator" aria-hidden="true">|</span>
        <a routerLink="/support-policy" matButton class="footer-link">Support</a>
        <span class="footer-separator" aria-hidden="true">|</span>
        <a routerLink="/terms-conditions" class="footer-link" matButton>Terms</a>
    </nav>
</footer>